import {Component, Input, OnInit} from '@angular/core';
import {NavController} from '@ionic/angular';
import {TeamModel} from 'src/app/models/team.model';
import {UserModel} from 'src/app/models/user.model';
import {GlobalService} from 'src/app/services/global/global.service';
import {TeamService} from 'src/app/services/team/team.service';
import {ApiResponse} from 'src/app/services/utils';

@Component({
    selector: 'app-team-invitation',
    templateUrl: './team-invitation.component.html',
    styleUrls: ['./team-invitation.component.scss'],
    standalone: false
})
export class TeamInvitationComponent implements OnInit {

  @Input() team: TeamModel;
  @Input() user: UserModel;

  memberFlag = true;

  constructor(
    private navController: NavController,
    private globalService: GlobalService,
    private teamService: TeamService
  ) {
  }

  ngOnInit() {
  }

  openTeamDetail(t: TeamModel) {
    if (t.isAdmin) {
      this.navController.navigateForward(['/app/team/view-team/' + t.id]);
    } else {
      this.navController.navigateForward(['/app/team/other-team/' + t.id]);
    }
  }

  acceptJoinRequest(teamId, userId) {
    const data = {teamId, userId};
    this.teamService.apiAcceptInvitation(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.memberFlag = false;
        this.globalService.presentToast(result.message);
      }
    });
  }

  declineJoinRequest(teamId, userId) {
    const data = {teamId, userId};

    this.teamService.apiRejectInvitation(data).subscribe((result: ApiResponse) => {
      if (result.status) {
        this.memberFlag = false;
        this.globalService.presentToast(result.message);
      }
    });
  }


}
